import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ListItemButton, ListItemIcon, ListItemText, Box } from "@mui/material";

function ListItems(props) {
  const location = useLocation();
  const { disabled = false } = props;
  const isActive = props.link === location.pathname;

  const linkStyle = {
    textDecoration: "none",
    pointerEvents: disabled ? "none" : "auto",
    width: "100%",
  };

  return (
    <Link to={props.link} style={linkStyle}>
      <ListItemButton 
        sx={{
          padding: props.mt ? "12px 8px" : "12px 16px",
          justifyContent: props.mt ? "center" : "flex-start",
          minHeight: "48px",
          borderRadius: "8px",
          margin: "2px 0",
          backgroundColor: isActive ? "#e3f2fd" : "transparent",
          color: isActive ? "#1976d2" : "#333333",
          position: "relative",
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? "none" : "auto",
          "&:hover": {
            backgroundColor: isActive ? "#e3f2fd" : "#f5f5f5",
          }
        }}
        disabled={disabled}
      >
        {/* Active indicator line */}
        {isActive && !props.mt && (
          <Box
            sx={{
              position: "absolute",
              left: 0,
              top: "50%",
              transform: "translateY(-50%)",
              width: "3px",
              height: "24px",
              backgroundColor: "#1976d2",
              borderRadius: "0 2px 2px 0",
            }}
          />
        )}
        
        <ListItemIcon 
          sx={{ 
            margin: props.mt ? "0" : "0 12px 0 0",
            minWidth: props.mt ? "auto" : "40px",
            color: isActive ? "#1976d2" : "#666666",
            "& .MuiSvgIcon-root": {
              fontSize: "20px"
            }
          }}
        >
          {props.icon}
        </ListItemIcon>
        
        {!props.mt && (
          <ListItemText
            primary={props.name}
            sx={{
              "& .MuiTypography-root": {
                fontSize: "14px",
                fontWeight: isActive ? "600" : "500",
                color: isActive ? "#1976d2" : "#333333",
                lineHeight: 1.4,
              }
            }}
          />
        )}
      </ListItemButton>
    </Link>
  );
}

export default ListItems;
